import {notification} from 'antd'

export const notify = (kind,obj) => notification[kind](obj)